// 在线吃瓜 · 栏目与文章数据（静态演示数据）

export type ArticleSection = {
  heading?: string;
  paragraphs: string[];
};

export type Article = {
  id: string;
  category: string;
  title: string;
  subtitle: string;
  tags: string[];
  author: string;
  date: string;
  readTime: string;
  views: number;
  image: string;
  content: ArticleSection[];
};

export type Channel = {
  id: string;
  name: string;
  en: string;
  brief: string;
  color: 'primary' | 'accent' | 'secondary';
};

export const channels: Channel[] = [
  { id: 'xingdong', name: '明星动态', en: 'Star Watch', brief: '进组、路透、红毯与片场的实时观察，把明星日常读成一个个有信息量的细节。', color: 'primary' },
  { id: 'baoliao', name: '小道消息', en: 'Rumor Alley', brief: '介于传闻与证实之间的边角信息，交叉验证后才会呈上桌面的爆料观察。', color: 'accent' },
  { id: 'shendu', name: '深度挖掘', en: 'Deep Dig', brief: '未删细节与隐藏线索的主战场，把镜头外被忽略的蛛丝马迹逐一展开。', color: 'secondary' },
  { id: 'bianliao', name: '边角料专栏', en: 'Trivia Desk', brief: '聚光灯照不到的角落：服装、道具、群演与场记，那些关于行业的边角料。', color: 'secondary' },
];

export const hotTags = ['未删细节', '隐藏线索', '路透', '杀青', '片场', '服装造型', '通告单', '回眸'];

export const articles: Article[] = [
  {
    id: 'zhi-xingdong-01',
    category: 'xingdong',
    title: '沈知夏连轴进组，三天拍完九十场对手戏的日程表被扒出',
    subtitle: '一份网友整理的行程推算，比官方通稿多出太多信息量，我们顺着时间线逐格对了一遍。',
    tags: ['明星动态', '进组', '日程', '对手戏'],
    author: '瓜田老农',
    date: '2026-09-06',
    readTime: '6 分钟',
    views: 128400,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20warm-toned%20behind%20the%20scenes%20photo%20of%20a%20young%20Chinese%20actor%20in%20modern%20streetwear%20sitting%20on%20a%20film%20set%20chair%20between%20takes%20holding%20a%20script%2C%20dark%20amber%20and%20burnt%20sienna%20color%20grading%2C%20soft%20cinematic%20lighting%2C%20film%20crew%20softly%20blurred%20in%20background%2C%20shallow%20depth%20of%20field%2C%20editorial%20magazine%20photography%2C%20textured%20warm%20cream%20and%20terracotta%20tones&width=1200&height=800&seq=chi-zhi-a1&orientation=landscape',
    content: [
      { paragraphs: ['上周一深夜，沈知夏工作室放出一张片场收工照，配文只有短短八个字："今日九十场，已收。"评论区瞬间炸开锅——要知道，一部体量不小的剧，单日戏份通常维持在十场上下，九十场这个数字本身就极不寻常。'] },
      { heading: '把通稿还原成时间线', paragraphs: ['顺着公开的路透、开机时间表和补光灯倒影，我们把那三天的工作切成了细碎的时间片。凌晨四点抵达化妆间、上午连续大段台词戏、中午仅一小时用餐、下午转场两次棚与外景，晚上回酒店前还补了两场特写。', '这背后其实藏着行业常见的"连轴补戏"逻辑：为了赶某个档期节点，制片方常把某位主演的戏集中在压缩的时间窗里拍完。九十场并非夸张营销，而是资源调度下真实可能发生的结果。'] },
      { heading: '藏起来的看点', paragraphs: ['比起数字本身，更值得留意的是通告单上消失的下午两小时。有片场工作人员的小道消息称，那两小时临时空出来，是为了配合一位飞行嘉宾的档期补拍同框镜头。若属实，这段未公开的对手戏，很可能就是下季度宣传片里的高光。', '目前官方仍未回应，我们仅作时间线推测，供瓜友交叉比对。真相，往往比官宣慢半拍。'] },
    ],
  },
  {
    id: 'zhi-xingdong-02',
    category: 'xingdong',
    title: '生日直播里角落替人挡镜头的"那双手"，被逐帧认了出来',
    subtitle: '一场看似普通的生日连线，藏着三处刻意避开的镜头语言。',
    tags: ['直播', '细节', '镜头语言', '生日'],
    author: '显微镜',
    date: '2026-08-30',
    readTime: '5 分钟',
    views: 98700,
    image: 'https://readdy.ai/api/search-image?query=Atmospheric%20warm%20editorial%20photograph%20of%20a%20small%20celebration%20corner%20backstage%20lit%20by%20warm%20tungsten%20spotlights%20with%20string%20lights%20and%20pastel%20balloons%2C%20a%20performer%20mid-gesture%20casting%20a%20long%20shadow%2C%20moody%20amber%20red%20accent%20lighting%2C%20cinematic%20bokeh%2C%20magazine%20feature%20photography%2C%20deep%20shadows%20with%20terracotta%20and%20golden%20highlights%2C%20textured%20atmosphere&width=1200&height=800&seq=chi-zhi-a2&orientation=landscape',
    content: [
      { paragraphs: ['生日直播原本平平无奇，直到有人截到右上角切镜时一闪而过的一只手——它快速把一盏偏暖的补光灯拨开，好让主角面光更匀。直播间里没人提起，但切片在网上疯转，网友称它是"今晚真正的幕后功臣"。'] },
      { heading: '三处被避开的镜头', paragraphs: ['我们把整场回放逐帧过了一遍，发现至少三处明显避让：一是某声问候响起时镜头被快速拉远，二是墙角出现半件外套时画面秒切，三是主角下意识回头时补光灯先一步转开。', '这些不是随机切镜，而是有意识的"防穿帮"操作。对常年看直播的瓜友来说，越是被藏起来的部分，往往越值得追。'] },
      { heading: '我们只能看到被允许看到的', paragraphs: ['直播是半成品现场，真正决定信息量的，是导演藏在画面之外的选择。那双手的主人是谁，目前仍停留在小道消息阶段。我们把这些蛛丝马迹摊开，是想说：吃瓜的乐趣，有时恰恰在于学会读镜头之外。'] },
    ],
  },
  {
    id: 'zhi-baoliao-01',
    category: 'baoliao',
    title: '开机宴上那句"改得漂亮"，到底是在夸编剧还是夸对手戏演员',
    subtitle: '一句席间玩笑被录进了饭局花絮，也把两个创作环节的关系摆上了台面。',
    tags: ['小道消息', '开机宴', '创作', '幕后'],
    author: '午夜场',
    date: '2026-08-24',
    readTime: '4 分钟',
    views: 76400,
    image: 'https://readdy.ai/api/search-image?query=Warm%20documentary%20style%20photo%20of%20a%20celebratory%20banquet%20table%20at%20a%20film%20crew%20dinner%2C%20golden%20hour%20light%2C%20steaming%20dishes%20and%20teacups%20on%20a%20round%20turntable%20table%2C%20shallow%20focus%20on%20hands%20raising%20a%20glass%2C%20cinematic%20amber%20color%20palette%2C%20editorial%20reportage%20photography%2C%20rich%20terracotta%20and%20cream%20tones%20with%20soft%20window%20light&width=1200&height=800&seq=chi-bao-a3&orientation=landscape',
    content: [
      { paragraphs: ['开机宴向来是信息浓度最高的场合之一。觥筹交错间，主创们放下防备，一句席间玩笑常常比十篇通稿更有信息量。这次被镜头捕捉到的那句"改得漂亮"，引发了两拨网友截然不同的解读。'] },
      { heading: '两种解读，两条线', paragraphs: ['挺编剧的一派认为，这句话是对临场改台词、让逻辑更顺的编剧工作的直接肯定；挺演员的一派则指出，说话人当时正对着对面坐的男主演举杯，语气里分明是"你这遍演得真对"的夸赞。', '其实两种解读并不冲突。好的对手戏，往往是剧本与表演互相抬轿的结果——谁改得好、谁接得住，本来就难分彼此。'] },
      { heading: '小道消息的正确打开方式', paragraphs: ['在真相揭晓前，"到底夸谁"只能作为茶余谈资。我们更愿意提醒一句：吃瓜不只看热闹，也要看行业机制。开机宴上的每一句客气话背后，都是创作团队真实的分工与默契，这才是值得长期观察的部分。'] },
    ],
  },
  {
    id: 'zhi-baoliao-02',
    category: 'baoliao',
    title: '一张普通通告单的边角信息，比工作室的官宣更有料',
    subtitle: '页脚一行小字、一个被划掉的日期，都是没有写进公告的真实工作流。',
    tags: ['小道消息', '通告单', '工作流', '解读'],
    author: '场记本',
    date: '2026-08-18',
    readTime: '5 分钟',
    views: 84500,
    image: 'https://readdy.ai/api/search-image?query=Overhead%20warm-toned%20photo%20of%20a%20film%20production%20call%20sheet%20and%20scheduling%20clipboard%20spread%20on%20a%20wooden%20work%20table%20beside%20a%20walkie-talkie%20and%20marker%20pens%2C%20soft%20window%20light%20casting%20gentle%20shadows%2C%20amber%20and%20honey%20tones%2C%20documentary%20editorial%20photography%2C%20clean%20textured%20paper%20background%20in%20cream%20and%20terracotta&width=1200&height=800&seq=chi-bao-a4&orientation=landscape',
    content: [
      { paragraphs: ['有瓜友在某个片场路透照里，发现化妆台边压着一张皱巴巴的通告单。把它放大再放大，我们读出了几行官方永远不会写的话。'] },
      { heading: '三个值得注意的细节', paragraphs: ['第一，拍摄地点栏被圆珠笔划掉又重写，说明原计划临时换了棚；第二，页脚一行小字写着"晚间视天气加场外景"，暗示剧组在赌一个能见度高的晴天；第三，某位演员的妆造时间比同组人多出整整一小时，这通常是特殊造型或伤效的前置信号。', '这三条连起来看，指向的可能是一次紧赶慢赶的转场拍摄——也解释了为何那段时间团队社交平台更新频率骤降。'] },
      { heading: '信息差即乐趣', paragraphs: ['官宣负责体面，通告单负责真实。我们整理这类边角信息，不是为了当侦探，而是想帮瓜友理解：一部作品被看到之前，凝结了多少外人看不见的临时与妥协。这本身就是另一种"吃透"。'] },
    ],
  },
  {
    id: 'zhi-shendu-01',
    category: 'shendu',
    title: '一张杀青合照里，藏着三条你可能没注意到的未删细节',
    subtitle: '站位、道具与背景板，都在替剧组说一些没说出口的话。',
    tags: ['深度挖掘', '杀青', '隐藏线索', '站位'],
    author: '深度挖掘机',
    date: '2026-09-02',
    readTime: '7 分钟',
    views: 152600,
    image: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20behind%20the%20scenes%20group%20moment%20of%20a%20film%20cast%20celebrating%20the%20final%20wrap%20holding%20a%20clapperboard%2C%20framed%20at%20golden%20hour%20with%20warm%20backlight%2C%20genuine%20laughter%2C%20terracotta%20and%20honey%20color%20grading%2C%20editorial%20documentary%20photography%2C%20textured%20warm%20background%20with%20soft%20film%20grain&width=1200&height=800&seq=chi-shen-a5&orientation=landscape',
    content: [
      { paragraphs: ['杀青合照是剧组的集体告别仪式，也是信息量最"满"的一张图。人们总盯着主角，却忽略镜头四周那些被随手摆进画面的东西——它们往往不是随手，而是精心安排。'] },
      { heading: '细节一：站位透露的戏份分配', paragraphs: ['照片里站在第二排偏左、全程微笑却没入镜核心的一位配角，在后来的宣传物料里几乎消失。若对照剧本围读的路透，会发现这个角色戏份并不轻——站位与后期露出之间的落差，值得留意。'] },
      { heading: '细节二与三：道具与背景板', paragraphs: ['背景板右下角贴着两张被撕掉一半的场次表，露出的编号跨度极大，暗示这部剧的拍摄并非按播出顺序进行；而主角手里那把未拆封的扇子，正是道具组早前在花絮里专门出过镜的"关键道具"——它出现在杀青照而非剧照里，多半是在埋下一季的线。', '三条线索彼此独立又互相呼应。吃瓜到这一层，才算真正吃到"未删细节"的甜头。'] },
    ],
  },
  {
    id: 'zhi-shendu-02',
    category: 'shendu',
    title: '剪辑台上被删掉的那 47 秒，可能是理解整季的钥匙',
    subtitle: '花絮里一闪而过的导播时间码，让我们试着还原了那段"不存在"的画面。',
    tags: ['深度挖掘', '剪辑', '时间码', '伏笔'],
    author: '粗剪间',
    date: '2026-08-12',
    readTime: '6 分钟',
    views: 110300,
    image: 'https://readdy.ai/api/search-image?query=Moody%20warm-toned%20photo%20of%20a%20film%20editing%20suite%20at%20night%2C%20dual%20monitors%20glowing%20with%20a%20color%20timeline%2C%20editor%20silhouette%20adjusting%20faders%2C%20deep%20amber%20and%20crimson%20ambient%20light%2C%20cinematic%20editorial%20photography%2C%20rich%20shadows%20and%20warm%20highlights%2C%20film%20grain%20texture&width=1200&height=800&seq=chi-shen-a6&orientation=landscape',
    content: [
      { paragraphs: ['某部剧的幕后花絮里，导播台上一闪而过的剪辑时间码比成片多出 47 秒。这 47 秒被删去了哪里、原本讲了什么，成了我们这期"深度挖掘"的切入点。'] },
      { heading: '从时间码反推画面', paragraphs: ['根据花絮中出现的场次标签与镜头编号，我们锁定了那 47 秒极可能属于第五集结尾与第六集开头之间的过渡——那里在成片中只用了一个转场硬切，情绪断裂得明显。', '删掉的多半是一段没有台词的环境铺陈：一个远景、一个空镜、两三秒沉默。这类画面最容易被当成"拖节奏"剪掉，却往往是全剧主题的点睛。'] },
      { heading: '删减有时是另一种保护', paragraphs: ['当然，删戏未必都藏着惊天秘密，也可能是试映反馈后的取舍。但理解一部作品，不该只看它保留了哪 47 秒，也要看它删掉了哪 47 秒。剪辑台上的每一次取舍，都在替创作者说话。'] },
    ],
  },
  {
    id: 'zhi-bianliao-01',
    category: 'bianliao',
    title: '服装替身的工作台：一件戏服在开拍前的三段人生',
    subtitle: '从面料库到人物小传，一件戏服要过多少手，才敢穿着它喊"开机"。',
    tags: ['边角料', '服装造型', '戏服', '幕后工种'],
    author: '布料间',
    date: '2026-08-28',
    readTime: '5 分钟',
    views: 69200,
    image: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20a%20costume%20wardrobe%20department%20with%20elegant%20vintage%20dresses%20hanging%20on%20a%20rolling%20rack%2C%20soft%20daylight%20from%20a%20tall%20window%2C%20muted%20amber%20and%20rust%20tones%2C%20fabric%20textures%20visible%2C%20cinematic%20documentary%20photography%2C%20calm%20textured%20cream%20background%20with%20warm%20clothing%20color%20palette&width=1200&height=800&seq=chi-bian-a7&orientation=landscape',
    content: [
      { paragraphs: ['观众记住一件戏服，往往因为一个高光镜头；而一件戏服真正被赋予意义，是从面料库开始的三段旅程。我们跟着一位服装组的活儿，把这过程捋了一遍。'] },
      { heading: '第一段：从人物小传到布料选择', paragraphs: ['拿到剧本那天，服装设计先做的不是量体，而是给角色写"穿衣逻辑"：他见什么人穿什么、情绪崩坏时袖口会怎样被攥皱。据此去面料库挑选时，克重、垂坠感和洗水后的褶皱感，比颜色本身更优先。'] },
      { heading: '第二、三段：试穿校准与做旧', paragraphs: ['试穿阶段，戏服要在演员身上做大量"第二次修改"——不是合身，而是让它看起来像已经生活过的衣服。做旧、磨边、洒水再烘干，都是为了抹掉"新衣感"。', '直到服装替身替演员完成走位、确认它在长镜头里不穿帮，这件戏服才算真正可以上镜。所以那句"穿的是角色"，从来不是一句客套。'] },
    ],
  },
  {
    id: 'zhi-bianliao-02',
    category: 'bianliao',
    title: '群演休息区的一碗泡面时间线，比正片更接近真实片场',
    subtitle: '我们记录下盒饭、泡面与候场之间的等待，那些不被看见的"在场"。',
    tags: ['边角料', '群演', '片场', '观察'],
    author: '候场区',
    date: '2026-08-08',
    readTime: '4 分钟',
    views: 55600,
    image: 'https://readdy.ai/api/search-image?query=Cozy%20warm-toned%20documentary%20photo%20of%20a%20crew%20break%20area%20during%20a%20short%20filming%20pause%2C%20a%20thermos%20and%20steaming%20instant%20noodle%20cup%20on%20a%20folding%20table%20with%20scattered%20headset%20and%20umbrella%2C%20soft%20daylight%2C%20cinematic%20honey%20and%20terracotta%20tones%2C%20editorial%20reportage%20photography%2C%20textured%20warm%20background&width=1200&height=800&seq=chi-bian-a8&orientation=landscape',
    content: [
      { paragraphs: ['正片里，群演是背景里的模糊人影；片场外，他们是最长时间"在场"的人。这一篇我们不聊主角，只聊聊候场区那碗泡面周围的真实时间。'] },
      { heading: '等待，才是群演的主线戏', paragraphs: ['凌晨集合、化妆候场、按场次被叫到镜头前走几步、再退回休息区待命。多数时间，他们面对的是一部手机、一壶热水和一张排满等待的椅子。泡面冒起的热气，往往就是他们短暂休息的开始。', '有人靠补觉攒体力，有人翻剧本琢磨下一场会不会"抢到镜头"，也有人只是安静地看片场一点点亮起来。这份耐心，是许多高光镜头背后被裁剪掉的基底。'] },
      { heading: '看见不被看见的人', paragraphs: ['写这篇边角料，是想把镜头调转方向：一部剧的质感，不只是主角和导演给的，也是无数候场的人用时间与等待垫出来的。下次看到路透里那片休息区，不妨多看两眼——那里面也许正坐着下一次热搜的主人。'] },
    ],
  },
];

export const faqs = [
  { q: '「在线吃瓜」和一般娱乐号有什么不同？', a: '我们更看重"吃透"。除了常规明星动态与热搜，还会专门做未删细节、隐藏线索与边角料的交叉整理，把一个事件的多方信息摊开，帮你判断哪些是真信息、哪些还需要验证。' },
  { q: '你们的内容是真的吗，会不会造谣？', a: '涉及事实的报道我们会标注来源并交叉核对；标注为"小道消息""推测"的部分，我们只用分析语言呈现，绝不把传闻包装成定论。吃瓜请理性，先辨真假再下结论。' },
  { q: '为什么很多分析用虚构或不具名的人物？', a: '娱乐观察关注的是行业机制与作品逻辑，而非对个人的猎奇。用虚构人物与泛指案例展开分析，既能把方法论讲透，也避免了无据指责，对我们、对当事人都是更负责的做法。' },
  { q: '如何投稿爆料或分享线索？', a: '你可以通过页面底部"关于我们"的投稿邮箱与我们联系。投稿请尽量附上可验证的时间、来源或截图，采用后会标注提供方式，并对来源做脱敏处理。' },
  { q: '内容会固定栏目长期更新吗？', a: '是的，明星动态、小道消息、深度挖掘与边角料四个栏目会持续更新，并会根据热点实时加更专题。欢迎常来"在线吃瓜"首页看今日热搜榜单。' },
];